import React from 'react';
import DistVariableLabour from '../Distribution/Warehousing/VariableLabour';

// =============================================================================
// Manufacturing › Variable Labour
// Reuses the Distribution shift-pattern planner (production runs shifts just
// like warehousing) with a factory heading. Only the MODULE differs, so the
// plans and the function catalogue are kept separate from Distribution's.
// =============================================================================
const VariableLabour = () => (
  <DistVariableLabour moduleCode="MOD_3_MAKE" title="Manufacturing · Variable Labour" />
);

export default VariableLabour;
